import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestStatusLegalView } from 'src/app/Model/RequestStatusLegalView';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequesStatusService } from 'src/app/Services/RequestStatus/RequesStatus.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-agency-legal-document',
  templateUrl: './agency-legal-document.component.html',
  styleUrls: ['./agency-legal-document.component.css']
})
export class AgencyLegalDocumentComponent implements OnInit {
  success = new EventEmitter();
  file: File;
  request: RequestModel;
  isValid: boolean = false;
  public legalDocument: any;
  public idProfile: number;
  public requestcode: string;
  public IdRequest: number;
  public isMobile: boolean = false;
  public checked: boolean;
  public messageText: string;
  form = new FormGroup({
    message: new FormControl('', [Validators.required, CustomValidators.emptyTextValidator()]),
  });
  get message() { return this.form.get('message'); }

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly RequestStatus: RequesStatusService,
    private readonly translate: TranslateService,
    private readonly requestService: RequestService,
    private readonly activeRoute: ActivatedRoute,
    private readonly lsService : SessionStorageService
  ) { }

  async ngOnInit() {
    this.IdRequest = this.activeRoute.snapshot.params.id;
    await this.loadRequest()
  }
async loadRequest(){
  await this.spinner.show();
  await this.requestService.getRequestById(this.IdRequest)
  .then(async (res) => {
    this.request = res
    this.lsService.setLSItem('RequestCode', res.RequestCode)
    this.lsService.setLSItem('IdRequest', res.Id.toString())
    this.lsService.setLSItem('type', res.ConnectionType.toString())
  })

this.requestcode = this.lsService.getLSItem("RequestCode");
this.getLegalDocumentsByRequest()
await this.spinner.hide();
}
  public DownloadFormat(url) {
    window.open(url, '_blank','noopener,noreferrer')
  }

  async StatusChange(status: boolean) {
    let res: ResponseData
    await this.spinner.show()

    let statusChange = new RequestStatusLegalView()

    statusChange.Approve = status;
    statusChange.IdComponent = 33;
    statusChange.IdProfile = this.idProfile;
    statusChange.IdRequest = this.IdRequest;

    if (status == null) {
      statusChange.message = this.messageText;
    }

    await this.RequestStatus.SetStatusAgencyDocumentLegal(statusChange).then(resp => {
      res = resp;
    })

    await this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
      this.loadRequest();
      this.success.emit();
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: res.head.error.description,
        icon: 'error'
      }
      )
    }
  }

  getLegalDocumentsByRequest() {
    this.RequestStatus.getAgencyDocumentLegal(this.IdRequest).then(res => {
      this.legalDocument = res;
      this.isValid = this.legalDocument.FileLink1 && this.legalDocument.FileLink2 ? true : false;
    })
  }

}
